module.exports = __webpack_public_path__ + "img/微课系统.6b2dfc64.svg";